var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n\t\t45-multimeda-stop-pause\r\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\tCreated with Sketch.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.Multimedia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multimedia-(Color)",
    transform: "translate(-898.000000, -903.000000)",
    stroke: "#263238",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "45-multimeda-stop-pause",
    transform: "translate(900.000000, 905.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Layer-1",
    fill: "#FFFFFF",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Layer-2",
    fill: "#597584",
    x: 30,
    y: 30,
    width: 40,
    height: 40
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.38853d7d715b83dc485e0935a46921e2.svg";
export { ForwardRef as ReactComponent };